import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const slides = [
    {
      title: "We Build Infrastructure",
      subtitle: "... and Forge Trust",
      description: "Construction & Roads: Leveling and excavation, base layers, concrete/asphalt, sidewalks and interlocking, electricity and lighting, water/drainage/communications networks",
      tags: ["Specification Compliance", "On-time Delivery", "Guaranteed Quality"],
      bgImage: "https://public.readdy.ai/ai/img_res/e89c7217e5a970ec0e95fca40e88b0f9.jpg"
    },
    {
      title: "Integrated Solutions for Oil Sector",
      description: "Equipment and material supply, O&M, API 650/653 pipelines tanks, NDT testing, HSE compliance",
      tags: ["Supply Chain", "NDT/API", "HSE"],
      bgImage: "https://readdy.ai/api/search-image?query=oil%20refinery%20industrial%20facility%20with%20pipelines%20tanks%20professional%20petroleum%20infrastructure%20modern%20industrial%20background%20clean%20minimalist%20style&width=1920&height=1080&seq=hero2&orientation=landscape"
    },
    {
      title: "Trust Forged from Experience",
      description: "Gold with Swiss standards | Government agency armament | Technical and financial consulting and contract management",
      tags: ["KYC/AML", "Export Control", "Feasibility"],
      bgImage: "https://readdy.ai/api/search-image?query=professional%20businessconsulting%20meeting%20modern%20office%20environment%20clean%20minimalist%20background%20industrial%20consulting%20theme%20professional%20atmosphere&width=1920&height=1080&seq=hero3&orientation=landscape"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="min-h-screen" dir="ltr">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-[1300] overflow-visible h-[72px]">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-[72px]">
            <Link className="flex items-center" to="/">
              <img 
                alt="VIPA Trading Company" 
                className="h-16 w-auto" 
                src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
              />
            </Link>
            
            <nav className="hidden lg:flex items-center space-x-8">
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/">
                Home
              </Link>
              <div className="relative">
                <button 
                  className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium flex items-center cursor-pointer whitespace-nowrap focus:outline-none focus:text-[#E71B25]"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  Services
                  <i className={`ri-arrow-down-s-line ml-1 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-0 min-w-[260px] bg-white rounded-lg shadow-lg border border-[#C3AAAB33] z-[1000]">
                    <div className="py-2">
                      <Link to="/services/construction" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Construction & Roads
                      </Link>
                      <Link to="/services/oil" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Oil & Gas
                      </Link>
                      <Link to="/services/gold" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Gold Trading
                      </Link>
                      <Link to="/services/defense" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Defense Systems
                      </Link>
                      <Link to="/consultation" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Consulting
                      </Link>
                    </div>
                  </div>
                )}
              </div>
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/about">
                About Us
              </Link>
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/contact">
                Contact
              </Link>
            </nav>

            <div className="hidden lg:flex items-center space-x-4">
              <a data-lang="ar" className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium cursor-pointer">
                العربية
              </a>
              <Link to="/contact">
                <button 
                  type="button" 
                  className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap border-2 border-[#E71B25] text-[#E71B25] hover:bg-[#E71B25] hover:text-white px-4 py-2 text-sm"
                >
                  Email Contact
                </button>
              </Link>
            </div>

            <button 
              className="lg:hidden text-[#595A5C] cursor-pointer" 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </header>

      <main>
        {/* Hero Section */}
        <section className="relative h-[80vh] sm:h-[60vh] md:h-[80vh] overflow-hidden">
          {slides.map((slide, index) => (
            <div 
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <div 
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${slide.bgImage})` }}
              >
                <div className="absolute inset-0 bg-black/50"></div>
              </div>
              <div className="container mx-auto px-4 h-full relative z-10">
                <div className="flex items-center h-full">
                  <div className="max-w-4xl text-left text-white py-24">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight drop-shadow-lg">
                      <span>{slide.title.split('...')[0]}</span>
                      {slide.subtitle && (
                        <span className="text-[#E71B25]">... {slide.subtitle}</span>
                      )}
                    </h1>
                    <p className="text-lg md:text-xl mb-6 leading-relaxed text-gray-100 drop-shadow-md max-w-3xl">
                      {slide.description}
                    </p>
                    <div className="flex flex-wrap gap-2 mb-8 justify-start">
                      {slide.tags.map((tag, tagIndex) => (
                        <span 
                          key={tagIndex}
                          className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-medium border border-white/30"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                    <div className="flex flex-col sm:flex-row gap-4 justify-start">
                      <Link 
                        to="/services"
                        className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-[#E71B25] text-white hover:bg-[#d11620] shadow-sm hover:shadow-md px-8 py-4 text-lg shadow-lg"
                      >
                        View Services
                      </Link>
                      <Link 
                        to="/contact"
                        className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap border-2 border-white text-white hover:bg-white hover:text-[#595A5C] px-8 py-4 text-lg shadow-lg"
                      >
                        Get Quote
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* Navigation Arrows */}
          <button 
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-200 z-20 w-12 h-12 flex items-center justify-center"
            onClick={prevSlide}
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <button 
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-200 z-20 w-12 h-12 flex items-center justify-center"
            onClick={nextSlide}
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>

          {/* Slide Indicators */}
          <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-3 z-20">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentSlide 
                    ? 'bg-[#E71B25] scale-125' 
                    : 'bg-white/50 hover:bg-white/70'
                }`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>

          {/* Progress Bar */}
          <div className="absolute bottom-0 left-0 w-full h-1 bg-white/20 z-20">
            <div 
              className="h-full bg-[#E71B25] transition-all duration-100 ease-linear"
              style={{ width: `${((currentSlide + 1) / slides.length) * 100}%` }}
            ></div>
          </div>
        </section>

        {/* About Section */}
        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="bg-white rounded-xl shadow-lg p-8 lg:p-12">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                <div className="order-2 lg:order-1">
                  <h2 className="text-4xl lg:text-5xl font-bold mb-6">
                    About Us
                  </h2>
                  <p className="text-lg leading-relaxed mb-8">
                    VIPA Trading Company is an integrated platform with engineering, strategic and security solutions, 
                    with local and international partnerships, and implementation according to global standards.
                  </p>
                  <Link to="/about">
                    <button 
                      type="button" 
                      className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-[#E71B25] text-white hover:bg-[#d11620] shadow-sm hover:shadow-md px-8 py-4 text-lg hover:scale-105 transition-transform duration-300"
                    >
                      Learn More About Us
                      <i className="ri-arrow-right-line ml-2"></i>
                    </button>
                  </Link>
                </div>
                <div className="order-1 lg:order-2">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-6">
                    <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 hover:scale-102 hover:shadow-md transition-all duration-300 cursor-pointer">
                      <div className="flex items-start gap-4">
                        <div className="w-10 h-10 bg-[#E71B25] rounded-lg flex items-center justify-center flex-shrink-0">
                          <i className="ri-eye-line text-white text-lg"></i>
                        </div>
                        <div className="flex-1">
                          <h3 className="text-lg font-bold mb-2">Vision</h3>
                          <p className="text-sm leading-relaxed">To be the first name in the Gulf in contracting, armament, and metal trading</p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 hover:scale-102 hover:shadow-md transition-all duration-300 cursor-pointer">
                      <div className="flex items-start gap-4">
                        <div className="w-10 h-10 bg-[#E71B25] rounded-lg flex items-center justify-center flex-shrink-0">
                          <i className="ri-target-line text-white text-lg"></i>
                        </div>
                        <div className="flex-1">
                          <h3 className="text-lg font-bold mb-2">Mission</h3>
                          <p className="text-sm leading-relaxed">Reliable and sustainable solutions with global quality and commitment to time and cost</p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 hover:scale-102 hover:shadow-md transition-all duration-300 cursor-pointer">
                      <div className="flex items-start gap-4">
                        <div className="w-10 h-10 bg-[#E71B25] rounded-lg flex items-center justify-center flex-shrink-0">
                          <i className="ri-heart-line text-white text-lg"></i>
                        </div>
                        <div className="flex-1">
                          <h3 className="text-lg font-bold mb-2">Values</h3>
                          <p className="text-sm leading-relaxed">Transparency • Professionalism • Security • Sustainability • Innovation</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-20 bg-[#F7F7F7]">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="text-center mb-16">
              <h2 className="text-5xl font-bold text-[#2B2C2E] mb-6">Our Services</h2>
              <p className="text-xl text-[#595A5C] max-w-2xl mx-auto">
                Specialized solutions covering five main areas. Choose a service to learn more details.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
              <Link className="block group" to="/services/construction">
                <div className="bg-white rounded-xl shadow-sm hover:shadow-xl border-t-4 border-[#E71B25] p-6 min-h-[280px] flex flex-col transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                  <div className="w-12 h-12 bg-[#E71B25] rounded-full flex items-center justify-center mb-4 group-hover:bg-[#d11620] transition-colors duration-300">
                    <i className="ri-road-map-line text-white text-xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#2B2C2E] mb-3 min-h-[56px] flex items-center">Construction & Roads</h3>
                  <p className="text-[#595A5C] mb-6 leading-relaxed flex-grow min-h-[72px]">
                    Design and implementation of roads, sidewalks and infrastructure according to approved specifications.
                  </p>
                  <div className="mt-auto">
                    <span className="inline-flex items-center justify-center px-4 py-2 border-2 border-[#E71B25] text-[#2B2C2E] rounded-lg font-medium transition-all duration-300 group-hover:bg-[#E71B25] group-hover:text-white whitespace-nowrap">
                      Service Details
                      <i className="ri-arrow-right-line ml-2"></i>
                    </span>
                  </div>
                </div>
              </Link>

              <Link className="block group" to="/services/oil">
                <div className="bg-white rounded-xl shadow-sm hover:shadow-xl border-t-4 border-[#E71B25] p-6 min-h-[280px] flex flex-col transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                  <div className="w-12 h-12 bg-[#E71B25] rounded-full flex items-center justify-center mb-4 group-hover:bg-[#d11620] transition-colors duration-300">
                    <i className="ri-oil-line text-white text-xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#2B2C2E] mb-3 min-h-[56px] flex items-center">Oil & Gas</h3>
                  <p className="text-[#595A5C] mb-6 leading-relaxed flex-grow min-h-[72px]">
                    Supply, operation and maintenance of facilities, pipelines and tanks with NDT and HSE reports.
                  </p>
                  <div className="mt-auto">
                    <span className="inline-flex items-center justify-center px-4 py-2 border-2 border-[#E71B25] text-[#2B2C2E] rounded-lg font-medium transition-all duration-300 group-hover:bg-[#E71B25] group-hover:text-white whitespace-nowrap">
                      Service Details
                      <i className="ri-arrow-right-line ml-2"></i>
                    </span>
                  </div>
                </div>
              </Link>

              <Link className="block group" to="/services/gold">
                <div className="bg-white rounded-xl shadow-sm hover:shadow-xl border-t-4 border-[#E71B25] p-6 min-h-[280px] flex flex-col transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                  <div className="w-12 h-12 bg-[#E71B25] rounded-full flex items-center justify-center mb-4 group-hover:bg-[#d11620] transition-colors duration-300">
                    <i className="ri-coins-line text-white text-xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#2B2C2E] mb-3 min-h-[56px] flex items-center">Gold Trading</h3>
                  <p className="text-[#595A5C] mb-6 leading-relaxed flex-grow min-h-[72px]">
                    Bars and Dore with testing and melting according to Swiss standards and KYC/AML compliance.
                  </p>
                  <div className="mt-auto">
                    <span className="inline-flex items-center justify-center px-4 py-2 border-2 border-[#E71B25] text-[#2B2C2E] rounded-lg font-medium transition-all duration-300 group-hover:bg-[#E71B25] group-hover:text-white whitespace-nowrap">
                      Service Details
                      <i className="ri-arrow-right-line ml-2"></i>
                    </span>
                  </div>
                </div>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 max-w-4xl mx-auto">
              <Link className="block group" to="/services/defense">
                <div className="bg-white rounded-xl shadow-sm hover:shadow-xl border-t-4 border-[#E71B25] p-6 min-h-[280px] flex flex-col transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                  <div className="w-12 h-12 bg-[#E71B25] rounded-full flex items-center justify-center mb-4 group-hover:bg-[#d11620] transition-colors duration-300">
                    <i className="ri-shield-line text-white text-xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#2B2C2E] mb-3 min-h-[56px] flex items-center">Defense Systems</h3>
                  <p className="text-[#595A5C] mb-6 leading-relaxed flex-grow min-h-[72px]">
                    Approved solutions within export controls and end-user certificates.
                  </p>
                  <div className="mt-auto">
                    <span className="inline-flex items-center justify-center px-4 py-2 border-2 border-[#E71B25] text-[#2B2C2E] rounded-lg font-medium transition-all duration-300 group-hover:bg-[#E71B25] group-hover:text-white whitespace-nowrap">
                      Service Details
                      <i className="ri-arrow-right-line ml-2"></i>
                    </span>
                  </div>
                </div>
              </Link>

              <Link className="block group" to="/consultation">
                <div className="bg-white rounded-xl shadow-sm hover:shadow-xl border-t-4 border-[#E71B25] p-6 min-h-[280px] flex flex-col transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                  <div className="w-12 h-12 bg-[#E71B25] rounded-full flex items-center justify-center mb-4 group-hover:bg-[#d11620] transition-colors duration-300">
                    <i className="ri-lightbulb-line text-white text-xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#2B2C2E] mb-3 min-h-[56px] flex items-center">Consulting</h3>
                  <p className="text-[#595A5C] mb-6 leading-relaxed flex-grow min-h-[72px]">
                    Feasibility studies, contract and risk management, and industrial and logistics expansion plans.
                  </p>
                  <div className="mt-auto">
                    <span className="inline-flex items-center justify-center px-4 py-1 border-2 border-[#E71B25] text-[#2B2C2E] rounded-lg font-medium transition-all duration-300 group-hover:bg-[#E71B25] group-hover:text-white whitespace-nowrap">
                      Service Details
                      <i className="ri-arrow-right-line ml-2"></i>
                    </span>
                  </div>
                </div>
              </Link>
            </div>

            <div className="text-center">
              <Link to="/services">
                <span className="inline-flex items-center justify-center px-8 py-4 bg-[#E71B25] text-white rounded-lg font-medium text-lg hover:bg-[#d11620] transition-all duration-300 shadow-sm hover:shadow-md whitespace-nowrap">
                  View All Services
                  <i className="ri-arrow-right-line ml-2"></i>
                </span>
              </Link>
            </div>
          </div>
        </section>

        {/* How We Work Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="text-center mb-16">
              <h2 className="text-5xl font-bold text-[#2B2C2E] mb-6">How We Work?</h2>
              <p className="text-xl text-[#595A5C] max-w-3xl mx-auto">
                An integrated work methodology that ensures achieving the best results and delivering projects according to the highest standards
              </p>
            </div>

            {/* Desktop Version */}
            <div className="hidden lg:block">
              <div className="relative">
                <div className="absolute top-1/2 left-0 right-0 h-1 bg-[#F7F7F7] transform -translate-y-1/2"></div>
                <div className="absolute top-1/9 left-0 h-1 bg-[#E71B25] transform -translate-y-1/2 w-full"></div>
                <div className="relative flex justify-between items-center">
                  {[
                    { icon: "ri-search-line", title: "Requirements Analysis", desc: "Comprehensive study of project needs and client requirements" },
                    { icon: "ri-calendar-line", title: "Planning & Scheduling", desc: "Detailed implementation plan and precise timeline" },
                    { icon: "ri-truck-line", title: "Supply & Approvals", desc: "Material supply and obtaining necessary licenses" },
                    { icon: "ri-tools-line", title: "Site Implementation", desc: "Start project implementation with quality monitoring" },
                    { icon: "ri-file-check-line", title: "Delivery & Documentation", desc: "Deliver completed project with comprehensive documentation" }
                  ].map((step, index) => (
                    <div key={index} className="flex flex-col items-center group">
                      <div className="w-20 h-20 bg-[#E71B25] rounded-full flex flex-col items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300 relative z-10">
                        <i className={`${step.icon} text-white text-2xl mb-1`}></i>
                        <span className="text-white text-xs font-bold">{index + 1}</span>
                      </div>
                      <div className="text-center max-w-48">
                        <h3 className="text-lg font-bold text-[#2B2C2E] mb-3 leading-tight">{step.title}</h3>
                        <p className="text-[#595A5C] text-sm leading-relaxed">{step.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Mobile Version */}
            <div className="lg:hidden">
              <div className="relative">
                <div className="absolute left-6 top-0 bottom-0 w-1 bg-[#E71B25]"></div>
                <div className="space-y-12">
                  {[
                    { icon: "ri-search-line", title: "Requirements Analysis", desc: "Comprehensive study of project needs and client requirements" },
                    { icon: "ri-calendar-line", title: "Planning & Scheduling", desc: "Detailed implementation plan and precise timeline" },
                    { icon: "ri-truck-line", title: "Supply & Approvals", desc: "Material supply and obtaining necessary licenses" },
                    { icon: "ri-tools-line", title: "Site Implementation", desc: "Start project implementation with quality monitoring" },
                    { icon: "ri-file-check-line", title: "Delivery & Documentation", desc: "Deliver completed project with comprehensive documentation" }
                  ].map((step, index) => (
                    <div key={index} className="flex items-start">
                      <div className="w-12 h-12 bg-[#E71B25] rounded-full flex items-center justify-center mr-6 flex-shrink-0 shadow-lg relative z-10">
                        <span className="text-white text-sm font-bold">{index + 1}</span>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center mb-3">
                          <div className="w-10 h-10 bg-[#F7F7F7] rounded-xl flex items-center justify-center mr-3">
                            <i className={`${step.icon} text-[#E71B25] text-lg`}></i>
                          </div>
                          <h3 className="text-lg font-bold text-[#2B2C2E]">{step.title}</h3>
                        </div>
                        <p className="text-[#595A5C] leading-relaxed ml-13">{step.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="text-center mt-16">
              <Link to="/contact">
                <span className="inline-flex items-center justify-center px-8 py-4 bg-[#E71B25] text-white rounded-lg font-medium text-lg hover:bg-[#d11620] transition-all duration-300 shadow-sm hover:shadow-md whitespace-nowrap cursor-pointer">
                  Request Technical Meeting
                  <i className="ri-calendar-check-line ml-3"></i>
                </span>
              </Link>
            </div>
          </div>
        </section>

        {/* Certifications Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-[#595A5C] mb-4">Certifications & Standards</h2>
              <p className="text-lg text-gray-600">We adhere to the highest international standards in all our work</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {[
                { icon: "ri-medal-line", title: "ISO 9001", desc: "Quality Management" },
                { icon: "ri-shield-check-line", title: "HSE", desc: "Health & Safety" },
                { icon: "ri-oil-line", title: "API", desc: "Petroleum Standards" },
                { icon: "ri-bank-line", title: "AML", desc: "Anti-Money Laundering" }
              ].map((cert, index) => (
                <div key={index} className="text-center group">
                  <div className="w-20 h-20 mx-auto mb-4 bg-gray-50 rounded-full flex items-center justify-center group-hover:bg-[#E71B25] transition-colors duration-300">
                    <i className={`${cert.icon} text-3xl text-[#595A5C] group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                  <h3 className="font-bold text-[#595A5C] text-lg mb-2">{cert.title}</h3>
                  <p className="text-gray-600 text-sm">{cert.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 bg-[#595A5C]">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center text-white">
                <div className="w-16 h-16 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-2xl"></i>
                </div>
                <div className="text-4xl font-bold mb-2">+10</div>
                <div className="text-lg text-gray-200">Years Experience</div>
              </div>
              <div className="text-center text-white">
                <div className="w-16 h-16 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-building-line text-2xl"></i>
                </div>
                <div className="text-4xl font-bold mb-2">+50</div>
                <div className="text-lg text-gray-200">Projects</div>
              </div>
              <div className="text-center text-white">
                <div className="w-16 h-16 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-team-line text-2xl"></i>
                </div>
                <div className="text-4xl font-bold mb-2">+20</div>
                <div className="text-lg text-gray-200">Partners</div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-[#E71B25] to-[#d11620]">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Ready to Start Your Project?</h2>
            <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
              Contact us to get a free consultation and customized quote
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact">
                <button 
                  type="button" 
                  className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-white text-[#E71B25] border-white hover:bg-gray-50 px-8 py-4 text-lg shadow-lg"
                >
                  Get Quote
                </button>
              </Link>
              <a href="mailto:info@vipatradingco.com">
                <button 
                  type="button" 
                  className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#E71B25] px-8 py-4 text-lg shadow-lg"
                >
                  Email Us
                </button>
              </a>
            </div>
          </div>
        </section>

        {/* Contact Forms */}
        <section id="email-form" className="py-16 bg-white">
          <div className="container mx-auto px-4 max-w-2xl">
            <div className="bg-white rounded-xl shadow-lg p-8 border">
              <h3 className="text-2xl font-bold text-[#2B2C2E] mb-6 text-center">Contact Us</h3>
              <form data-readdy-form id="email-contact-form" onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.target as HTMLFormElement);
                const data = new URLSearchParams();
                for (const [key, value] of formData.entries()) {
                  data.append(key, value as string);
                }
                fetch('https://readdy.ai/api/form/d2rah42jqms3b5jftrb0', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                  body: data
                }).then(() => alert('Message sent successfully!'));
              }}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label className="block text-sm font-medium text-[#2B2C2E] mb-2">Full Name</label>
                    <input type="text" name="name" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E71B25] focus:border-transparent" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#2B2C2E] mb-2">Email</label>
                    <input type="email" name="email" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E71B25] focus:border-transparent" />
                  </div>
                </div>
                <div className="mb-6">
                  <label className="block text-sm font-medium text-[#2B2C2E] mb-2">Subject</label>
                  <input type="text" name="subject" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E71B25] focus:border-transparent" />
                </div>
                <div className="mb-6">
                  <label className="block text-sm font-medium text-[#2B2C2E] mb-2">Message</label>
                  <textarea name="message" rows={5} maxLength={500} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E71B25] focus:border-transparent resize-none" placeholder="Write your message here..."></textarea>
                </div>
                <button type="submit" className="w-full bg-[#E71B25] text-white py-3 px-6 rounded-lg font-medium hover:bg-[#d11620] transition-colors duration-200 whitespace-nowrap">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#2B2C2E] text-white">
        <div className="container mx-auto px-4 py-16">
          <div className="hidden md:grid md:grid-cols-4 gap-12">
            <div className="space-y-6 md:col-span-2">
              <div>
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 flex items-center justify-center mr-4">
                    <img 
                      alt="VIPA Trading Company" 
                      className="h-16 w-auto" 
                      src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
                    />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-1">VIPA Trading Company</h2>
                    <p className="text-[#E71B25] text-sm font-medium">شركة فيبا التجارية</p>
                  </div>
                </div>
                <p className="text-gray-300 text-base leading-relaxed mb-6">
                  A leading Kuwaiti multi-activity company, we provide integrated solutions in construction and roads, oil, gold, armament, and consulting with the highest global quality standards.
                </p>
                <div className="space-y-3">
                  <a href="mailto:info@vipatradingco.com" className="text-gray-300 hover:text-[#E71B25] transition-colors text-base inline-flex items-center cursor-pointer group">
                    <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center mr-3 group-hover:bg-[#E71B25] transition-colors">
                      <i className="ri-mail-line text-sm"></i>
                    </div>
                    info@vipatradingco.com
                  </a>
                  <div className="text-gray-300 text-base inline-flex items-center">
                    <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-map-pin-line text-sm"></i>
                    </div>
                    Kuwait
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-white font-bold text-xl mb-8 relative">
                Quick Links
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#E71B25]"></div>
              </h3>
              <ul className="space-y-4">
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group" to="/"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Home</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group" to="/services"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Services</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group" to="/about"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>About Us</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group" to="/contact"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Contact</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-bold text-xl mb-8 relative">
                Our Services
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#E71B25]"></div>
              </h3>
              <ul className="space-y-4">
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group" to="/services/construction"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Construction & Roads</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group" to="/services/oil"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Oil & Gas</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group" to="/services/gold"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Gold Trading</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group" to="/services/defense"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Defense Systems</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base py-2 cursor-pointer block group" to="/consultation"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Consulting</Link></li>
              </ul>
            </div>
          </div>

          {/* Mobile Footer */}
          <div className="md:hidden space-y-6">
            <div className="space-y-4 pb-8 border-b border-gray-600">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 flex items-center justify-center mr-3">
                  <img 
                    alt="VIPA Trading Company" 
                    className="h-12 w-auto" 
                    src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
                  />
                </div>
                <div>
                  <h2 className="text-xl font-bold text-white">VIPA Trading Company</h2>
                  <p className="text-[#E71B25] text-xs">شركة فيبا التجارية</p>
                </div>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed mb-4">
                A leading Kuwaiti multi-activity company providing integrated solutions in various fields with the highest quality standards.
              </p>
              <div className="space-y-3">
                <a href="mailto:info@vipatradingco.com" className="text-gray-300 hover:text-[#E71B25] transition-colors text-sm inline-flex items-center cursor-pointer">
                  <i className="ri-mail-line mr-2"></i>info@vipatradingco.com
                </a>
                <div className="text-gray-300 text-sm inline-flex items-center">
                  <i className="ri-map-pin-line mr-2"></i>Kuwait
                </div>
              </div>
            </div>
          </div>

          <div className="mt-16 pt-8 border-t border-gray-600">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <p className="text-gray-400 text-sm">© 2025 VIPA Trading Company — All rights reserved.</p>
              <div className="flex flex-col md:flex-row md:items-center gap-4">
                <div className="flex items-center gap-4">
                  <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group">
                    <i className="ri-linkedin-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group">
                    <i className="ri-instagram-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group">
                    <i className="ri-twitter-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                </div>
                <div className="flex items-center gap-3 md:border-l md:border-gray-600 md:pl-4">
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-medal-line text-[#E71B25]"></i>
                    <span>ISO 9001</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-shield-check-line text-[#A71B25]"></i>
                    <span>HSE Certified</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
